import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { CompanyDataAnalysisOptions, defaultChartOrTableHeight } from './CompanyDataAnalysisService';
import { Symbols } from '@/symbols';
import _ from 'lodash';
import { CompanyDataAnalysisEventKey, CompanyDataAnalysisKeyType } from '@/apis/service/company/CompanyDataAnalysisApi.type';
import { CompanyDataAnalysisViewType } from './CompanyDataAnalysis.type';
let CompanyEurekaAIRDataAnalysisService = class CompanyEurekaAIRDataAnalysisService {
    constructor(companyDataAnalysisService, companyDataAnalysisApi, i18n) {
        this.companyDataAnalysisService = companyDataAnalysisService;
        this.companyDataAnalysisApi = companyDataAnalysisApi;
        this.i18n = i18n;
        // 新增用户配置
        this.newUserPermissionOption = new CompanyDataAnalysisOptions();
        /**
         * 新用户获取权限 Detail 配置
         */
        this.newUserPermissionDetailOption = new CompanyDataAnalysisOptions();
        this.eurekaAIRActiveUserDetailOption = new CompanyDataAnalysisOptions();
        // TechSeek 配置
        this.techSeekOption = new CompanyDataAnalysisOptions();
        // TechMind 配置
        this.techMindOption = new CompanyDataAnalysisOptions();
        // techResearch create report 配置
        this.techResearchCreateReportOption = new CompanyDataAnalysisOptions();
        // techResearch view report 配置
        this.techResearchViewReportOption = new CompanyDataAnalysisOptions();
        this.newUserPermissionConfigInit();
        this.newUserPermissionDetailConfigInit();
        this.eurekaAIRActiveUserDetailConfigInit();
        this.techSeekConfigInit();
        this.techMindConfigInit();
        this.techResearchCreateReportConfigInit();
        this.techResearchViewReportConfigInit();
    }
    newUserPermissionConfigInit() {
        this.newUserPermissionOption.reportName = CompanyDataAnalysisKeyType.EUREKA_AIR_NEW_USER;
        this.newUserPermissionOption.title = this.i18n.t('backoffice.company.dataAnalysis.overview');
        this.newUserPermissionOption.canCollapse = false;
        this.newUserPermissionOption.tips = [];
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.NewUserPermission'),
        };
        this.newUserPermissionOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.newUserPermissionOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.newUserPermissionOption.statistics = [];
        this.newUserPermissionOption.chartId = 'newEurekaAIRUserPermissionChart';
        this.newUserPermissionOption.chartHeight = defaultChartOrTableHeight.defaultChartHeight;
    }
    getNewUserPermissionData(params) {
        this.newUserPermissionOption.loading = true;
        const newUserPermissionParams = { ...params, report_name: this.newUserPermissionOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(newUserPermissionParams).then(data => {
            this.newUserPermissionOption.Updated = data.data_date;
            this.newUserPermissionDetailOption.Updated = data.data_date;
            this.eurekaAIRActiveUserDetailOption.Updated = data.data_date;
            this.newUserPermissionOption.noData = data.data_detail.length === 0;
            this.newUserPermissionOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.EUREKA_AIR);
            const optionParams = {
                data: data.data_detail,
                user_count: this.i18n.t('backoffice.company.dataAnalysis.NewUserPermission'),
                key: CompanyDataAnalysisEventKey.EUREKA_AIR,
            };
            this.newUserPermissionOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.newUserPermissionOption.noData = true;
        }).finally(() => {
            this.newUserPermissionOption.loading = false;
        });
    }
    newUserPermissionDetailConfigInit() {
        this.newUserPermissionDetailOption.reportName = CompanyDataAnalysisKeyType.EUREKA_AIR_NEW_USER;
        this.newUserPermissionDetailOption.title = this.i18n.t('backoffice.company.dataAnalysis.userDetails');
        this.newUserPermissionDetailOption.tips = [
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.eureka_airLoginCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.eureka_airLoginCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.eureka_airLoginTotalCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.eureka_airLoginTotalCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.joinDate'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.joinDateTips'),
            }
        ];
        this.newUserPermissionDetailOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.newUserPermissionDetailOption.tableOptions.paginationOptions.enabled = true;
        this.newUserPermissionDetailOption.tableOptions.paginationOptions.perPageDropdownEnabled = false;
        this.newUserPermissionDetailOption.canChangeViewType = false;
        this.newUserPermissionDetailOption.viewType = CompanyDataAnalysisViewType.Table;
        this.newUserPermissionDetailOption.canCollapse = false;
        this.newUserPermissionDetailOption.tableFields = this.companyDataAnalysisService.getUserTableColumns(CompanyDataAnalysisEventKey.EUREKA_AIR);
        this.newUserPermissionDetailOption.tableOptions.columns = this.newUserPermissionDetailOption.tableFields;
    }
    async getNewUserPermissionDetailsData(params) {
        let newUserPermissionDetailParams = _.cloneDeep(params);
        this.newUserPermissionDetailOption.loading = true;
        newUserPermissionDetailParams = this.companyDataAnalysisService.getDetailTableDefaultParams(params, this.newUserPermissionDetailOption.reportName);
        // 先获取字段设置
        this.newUserPermissionDetailOption.tableOptions.columns = await this.companyDataAnalysisService.getFiledSettingColumns(this.newUserPermissionOption.reportName, this.newUserPermissionDetailOption.tableFields);
        return this.companyDataAnalysisApi.getCompanyDataAnalysisUserPrivileges(newUserPermissionDetailParams).then(data => {
            this.newUserPermissionDetailOption.noData = data.iTotalRecords === 0;
            this.newUserPermissionDetailOption.tableOptions.paginationOptions.setCurrentPage = Number(data.s_echo);
            this.newUserPermissionDetailOption.tableOptions.totalRecords = data.iTotalRecords;
            this.newUserPermissionDetailOption.tableOptions.totalRows = data.iTotalDisplayRecords;
            this.newUserPermissionDetailOption.tableOptions.rows = this.companyDataAnalysisService.getUserTableRows(data.aaData, CompanyDataAnalysisEventKey.EUREKA_AIR);
        }).catch(() => {
            this.newUserPermissionDetailOption.noData = true;
        }).finally(() => {
            this.newUserPermissionDetailOption.loading = false;
        });
    }
    eurekaAIRActiveUserDetailConfigInit() {
        this.eurekaAIRActiveUserDetailOption.reportName = CompanyDataAnalysisKeyType.EUREKA_AIR_SUMMARY;
        this.eurekaAIRActiveUserDetailOption.title = this.i18n.t('backoffice.company.dataAnalysis.activeUserTitle');
        this.eurekaAIRActiveUserDetailOption.tips = [
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.eureka_airLoginCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.eureka_airLoginCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.eureka_airLoginTotalCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.eureka_airLoginTotalCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.eureka_air_techSeek'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.eureka_air_techSeekTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.eureka_air_techMind'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.eureka_air_techMindTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.eureka_air_techResearch'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.eureka_air_techResearchTips'),
            }
        ];
        this.eurekaAIRActiveUserDetailOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeight;
        this.eurekaAIRActiveUserDetailOption.tableOptions.paginationOptions.enabled = true;
        this.eurekaAIRActiveUserDetailOption.tableOptions.paginationOptions.perPageDropdownEnabled = false;
        this.eurekaAIRActiveUserDetailOption.canChangeViewType = false;
        this.eurekaAIRActiveUserDetailOption.viewType = CompanyDataAnalysisViewType.Table;
        this.eurekaAIRActiveUserDetailOption.canCollapse = true;
        this.eurekaAIRActiveUserDetailOption.tableFields = this.companyDataAnalysisService.getEurekaAirActiveUserTableColumns();
        this.eurekaAIRActiveUserDetailOption.tableOptions.columns = this.eurekaAIRActiveUserDetailOption.tableFields;
    }
    async getEurekaActiveUserDetailData(params) {
        let eurekaActiveUserDetailParams = _.cloneDeep(params);
        this.eurekaAIRActiveUserDetailOption.loading = true;
        eurekaActiveUserDetailParams = this.companyDataAnalysisService.getDetailTableDefaultParams(params, this.eurekaAIRActiveUserDetailOption.reportName);
        // 先获取字段设置
        this.eurekaAIRActiveUserDetailOption.tableOptions.columns = await this.companyDataAnalysisService.getFiledSettingColumns(this.eurekaAIRActiveUserDetailOption.reportName, this.eurekaAIRActiveUserDetailOption.tableFields);
        return this.companyDataAnalysisApi.getCompanyDataAnalysisUserPrivilegesSummary(eurekaActiveUserDetailParams).then(data => {
            this.eurekaAIRActiveUserDetailOption.noData = data.iTotalRecords === 0;
            this.eurekaAIRActiveUserDetailOption.tableOptions.paginationOptions.setCurrentPage = Number(data.s_echo);
            this.eurekaAIRActiveUserDetailOption.tableOptions.totalRecords = data.iTotalRecords;
            this.eurekaAIRActiveUserDetailOption.tableOptions.totalRows = data.iTotalDisplayRecords;
            this.eurekaAIRActiveUserDetailOption.tableOptions.rows = this.companyDataAnalysisService.getEurekaAIRTableRows(data.aaData);
        }).catch(() => {
            this.eurekaAIRActiveUserDetailOption.noData = true;
        }).finally(() => {
            this.eurekaAIRActiveUserDetailOption.loading = false;
        });
    }
    techSeekConfigInit() {
        this.techSeekOption.reportName = CompanyDataAnalysisKeyType.EUREKA_AIR_TECH_SEEK;
        this.techSeekOption.title = this.i18n.t('backoffice.company.dataAnalysis.EurekaAIR_TechSeek');
        this.techSeekOption.tips = [
            {
                label: '',
                desc: this.i18n.t('backoffice.company.dataAnalysis.eurekaAIRTechSeekTips'),
            }
        ];
        this.techSeekOption.canCollapse = true;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            total_count: this.i18n.t('backoffice.company.dataAnalysis.commonPv'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.commonUv'),
        };
        this.techSeekOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.techSeekOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.techSeekOption.chartId = 'techSeekAnalysis';
        this.techSeekOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getTechSeekData(params) {
        this.techSeekOption.loading = true;
        const searchParams = { ...params, report_name: this.techSeekOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(searchParams).then(data => {
            this.techSeekOption.Updated = data.data_date;
            this.techSeekOption.noData = data.data_detail.length === 0;
            const statistics = {
                total_count: data.total_count,
                user_count: data.user_count,
                key: 'techSeek',
            };
            this.techSeekOption.statistics = this.companyDataAnalysisService.getPvUvStatistics(statistics);
            this.techSeekOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.EUREKA_AIR_TECH_SEEK);
            const optionParams = {
                data: data.data_detail,
                total_count: this.techSeekOption.statistics[0].label,
                user_count: this.techSeekOption.statistics[1].label,
                key: CompanyDataAnalysisEventKey.EUREKA_AIR_TECH_SEEK,
            };
            this.techSeekOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.techSeekOption.noData = true;
        }).finally(() => {
            this.techSeekOption.loading = false;
        });
    }
    techMindConfigInit() {
        this.techMindOption.reportName = CompanyDataAnalysisKeyType.EUREKA_AIR_TECH_MIND;
        this.techMindOption.title = this.i18n.t('backoffice.company.dataAnalysis.EurekaAIR_TechMind');
        this.techMindOption.canCollapse = true;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            total_count: this.i18n.t('backoffice.company.dataAnalysis.commonPv'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.commonUv'),
        };
        this.techMindOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.techMindOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.techMindOption.chartId = 'techMindAnalysis';
        this.techMindOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getTechMindData(params) {
        this.techMindOption.loading = true;
        const searchParams = { ...params, report_name: this.techMindOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(searchParams).then(data => {
            this.techMindOption.Updated = data.data_date;
            this.techMindOption.noData = data.data_detail.length === 0;
            const statistics = {
                total_count: data.total_count,
                user_count: data.user_count,
                key: 'techMind',
            };
            this.techMindOption.statistics = this.companyDataAnalysisService.getPvUvStatistics(statistics);
            this.techMindOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.EUREKA_AIR_TECH_MIND);
            const optionParams = {
                data: data.data_detail,
                total_count: this.techMindOption.statistics[0].label,
                user_count: this.techMindOption.statistics[1].label,
                key: CompanyDataAnalysisEventKey.EUREKA_AIR_TECH_MIND,
            };
            this.techMindOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.techMindOption.noData = true;
        }).finally(() => {
            this.techMindOption.loading = false;
        });
    }
    techResearchCreateReportConfigInit() {
        this.techResearchCreateReportOption.reportName = CompanyDataAnalysisKeyType.EUREKA_AIR_TECH_RESEARCH_CREATE;
        this.techResearchCreateReportOption.title = this.i18n.t('backoffice.company.dataAnalysis.techResearchCreateReport');
        this.techResearchCreateReportOption.canCollapse = false;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            total_count: this.i18n.t('backoffice.company.dataAnalysis.commonPv'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.commonUv'),
        };
        this.techResearchCreateReportOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.techResearchCreateReportOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.techResearchCreateReportOption.chartId = 'techResearchCreateReportAnalysis';
        this.techResearchCreateReportOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getTechResearchCreateReportData(params) {
        this.techResearchCreateReportOption.loading = true;
        const searchParams = { ...params, report_name: this.techResearchCreateReportOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(searchParams).then(data => {
            this.techResearchCreateReportOption.Updated = data.data_date;
            this.techResearchCreateReportOption.noData = data.data_detail.length === 0;
            const statistics = {
                total_count: data.total_count,
                user_count: data.user_count,
                key: 'techResearchCreateReport',
            };
            this.techResearchCreateReportOption.statistics = this.companyDataAnalysisService.getPvUvStatistics(statistics);
            this.techResearchCreateReportOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.EUREKA_AIR_TECH_RESEARCH_CREATE);
            const optionParams = {
                data: data.data_detail,
                total_count: this.techResearchCreateReportOption.statistics[0].label,
                user_count: this.techResearchCreateReportOption.statistics[1].label,
                key: CompanyDataAnalysisEventKey.EUREKA_AIR_TECH_RESEARCH_CREATE,
            };
            this.techResearchCreateReportOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.techResearchCreateReportOption.noData = true;
        }).finally(() => {
            this.techResearchCreateReportOption.loading = false;
        });
    }
    techResearchViewReportConfigInit() {
        this.techResearchViewReportOption.reportName = CompanyDataAnalysisKeyType.EUREKA_AIR_TECH_RESEARCH_VIEW;
        this.techResearchViewReportOption.title = this.i18n.t('backoffice.company.dataAnalysis.techResearchViewReport');
        this.techResearchViewReportOption.canCollapse = false;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            total_count: this.i18n.t('backoffice.company.dataAnalysis.commonPv'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.commonUv'),
        };
        this.techResearchViewReportOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.techResearchViewReportOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.techResearchViewReportOption.chartId = 'techResearchViewReportAnalysis';
        this.techResearchViewReportOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getTechResearchViewReportData(params) {
        this.techResearchViewReportOption.loading = true;
        const searchParams = { ...params, report_name: this.techResearchViewReportOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(searchParams).then(data => {
            this.techResearchViewReportOption.Updated = data.data_date;
            this.techResearchViewReportOption.noData = data.data_detail.length === 0;
            const statistics = {
                total_count: data.total_count,
                user_count: data.user_count,
                key: 'techResearchViewReport',
            };
            this.techResearchViewReportOption.statistics = this.companyDataAnalysisService.getPvUvStatistics(statistics);
            this.techResearchViewReportOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.EUREKA_AIR_TECH_RESEARCH_VIEW);
            const optionParams = {
                data: data.data_detail,
                total_count: this.techResearchViewReportOption.statistics[0].label,
                user_count: this.techResearchViewReportOption.statistics[1].label,
                key: CompanyDataAnalysisEventKey.EUREKA_AIR_TECH_RESEARCH_VIEW,
            };
            this.techResearchViewReportOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.techResearchViewReportOption.noData = true;
        }).finally(() => {
            this.techResearchViewReportOption.loading = false;
        });
    }
    initData(params) {
        Promise.all([
            this.getNewUserPermissionData(params),
            this.getNewUserPermissionDetailsData(params),
            this.getEurekaActiveUserDetailData(params),
            this.getTechSeekData(params),
            this.getTechMindData(params),
            this.getTechResearchCreateReportData(params),
            this.getTechResearchViewReportData(params)
        ]);
    }
};
CompanyEurekaAIRDataAnalysisService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CompanyDataAnalysisService)),
    __param(1, inject(Symbols.CompanyDataAnalysisApi)),
    __param(2, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object, Object])
], CompanyEurekaAIRDataAnalysisService);
export { CompanyEurekaAIRDataAnalysisService };
